<ng-container *ngIf="extraJob$ | async as extraJob">
  <app-checkout-page
    [country]="country$ | async"
    [orderData]="extraJob"
    [redirectUrl]="redirectUrl"
    [redirectQueryParams]="redirectQueryParams"
    [shouldRedirect]="shouldRedirect"
  ></app-checkout-page>
</ng-container>
